import MultipleAreaLocation from "./MultipleAreaLocation";

export default MultipleAreaLocation;
